var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "waf-component waf-error-page" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "error-wrapper" }, [
            _c("div", { staticClass: "error-inn-wrapper" }, [
              _c("div", { staticClass: "error-msg-wrap" }, [
                _c("div", { staticClass: "error-no" }, [
                  _c("h3", { staticClass: "title" }, [
                    _c("span", [_vm._v("4")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cham-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/static-assets/images/cssimages/error-cham.svg",
                          alt: "",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("4")]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "error-msg" }, [
                  _c("p", { staticClass: "txt1" }, [
                    _vm._v("Sorry, page not found"),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "txt2" }, [
                    _vm._v(
                      " The page you are looking for may have been\n                              moved, updated or deleted. "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a", { staticClass: "btn", attrs: { href: "/" } }, [
                    _vm._v("back to home"),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }